var TokenIterator = require("./TokenIterator");

exports.Parser = function(options) {
    var parseTokens = function(parser, tokens) {
        return parser(new TokenIterator(tokens));
    };
    
    return {
        parseTokens: parseTokens
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lop/lib/parser.js
// module id = 1949
// module chunks = 0